import React, {useState,useEffect} from 'react'
import axios from 'axios'
import ReactDOM from 'react-dom/client'
import './scss/style.css'
const APIURL = process.env.NODE_ENV === 'production' ? `${process.env.REACT_APP_DB_ENV}` : `${process.env.REACT_APP_DB_ENV_TEST}`
export function App() {
  const [loadDt, setLoadDt] = useState(null)
  const [dt,setDt]=useState([{"id":1,"name":"kiwi"},{"id":2,"name":"apple"}])
  const [selectedId,setSelectedId]=useState('')
  const [selectedItem,setSelectedItem]=useState('')
  useEffect(() => {
    if(loadDt==null){
        const handleSubmit = async (e) => {
          onClick2GetAll()
          setLoadDt(true)
        }
     setTimeout(handleSubmit, 1)
    }
  })
  const onClick2GetAll=async()=>{
    const {data:res1}=await axios.get(`${APIURL}/fruits/all`)
    setDt(res1)
  }
  const onClick2Add=async()=>{
    const {data:res1}=await axios.get(`${APIURL}/fruits/add`)
    setDt(res1)
  }
  async function onClick2Get(id){
    const {data:res1}=await axios.get(`${APIURL}/fruits/${id}`)
    setSelectedId(res1.id)
    setSelectedItem(res1)
  }
  const onChange2Input=({currentTarget:x1})=>{ 
    setSelectedItem({...selectedItem,[x1.name]:x1.value}) 
  }
  const onClick2Update=async()=>{
    console.log(selectedItem)
      const {data:res1}=await axios.post(`${APIURL}/fruits/${selectedId}`,selectedItem)
      // const {data:res1}=await axios.get(`${APIURL}/apple1`)
      console.log(res1)
      setDt(res1)
  }
  const onClick2Delete=async()=>{
    console.log('clicked delete')
      const {data:res1}=await axios.delete(`${APIURL}/fruits/${selectedId}`)
      console.log(res1)
      setSelectedId('')
      setDt(res1)
  }

  return (
    <div className='App'>
      react + c++<br/>
      /fruits/all<button className="ml-[4px] mb-[2px] rounded-[4px] pl-[16px] pr-[16px] border-1 bg-gray-800 hover:bg-gray-700 text-white" onClick={onClick2GetAll}>all</button><button className="ml-[4px] mb-[2px] rounded-[4px] pl-[16px] pr-[16px] border-1 bg-gray-800 hover:bg-gray-700 text-white" onClick={onClick2Add}>add</button><br/>
      /fruits/id<button className="ml-[4px] mb-[2px] rounded-[4px] pl-[16px] pr-[16px] border-1 bg-gray-800 hover:bg-gray-700 text-white" onClick={onClick2Get}>get</button><button className="ml-[4px] mb-[2px] rounded-[4px] pl-[16px] pr-[16px] border-1 bg-gray-800 hover:bg-gray-700 text-white" onClick={onClick2Update}>update</button><button className="ml-[4px] mb-[2px] rounded-[4px] pl-[16px] pr-[16px] border-1 bg-gray-800 hover:bg-gray-700 text-white" onClick={onClick2Delete}>delete</button><br/>
      {APIURL}<br/>
      {dt.map(x=><div className={`cursor-default hover:bg-blue-100 ${selectedId==x.id?'bg-blue-100':''}`} onClick={()=>onClick2Get(x.id)}>id: {x.id} name: {x.name}</div>)}
      <br/>
      {selectedId==''?'select item to change':<div>id: <input name='id' className='border border-gray-950 mb-1 w-[20px] mr-[2px]' value={selectedItem.id} onChange={onChange2Input}/>name: <input name='name' className='border border-gray-950 mb-1 w-[100px]' value={selectedItem.name} onChange={onChange2Input}/></div>}<br/>
    </div>
  )
}

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)